import { reducerFactory } from '../dependencies';
import { languages } from '../config';

export default reducerFactory(languages);
